import {
  useServiceProvidersCheckboxesGroupMapper
} from '../../../projects/clientportal/ServiceProvidersGroupSelector';

import { DefaultPortalConfiguration } from './defaultPortalConfigurationService';

export type FormType = Omit<DefaultPortalConfiguration, 'serviceProvidersLinks'> & {
  serviceProvidersLinks: Record<number, number[]>
};

export function useFormMapper() {
  const checkboxesGroupMapper = useServiceProvidersCheckboxesGroupMapper();

  const toFormView = (data: DefaultPortalConfiguration) => {
    return {
      ...data,
      serviceProvidersLinks: checkboxesGroupMapper.toFormView(data.serviceProvidersLinks),
    };
  };

  const toApiView = (data: FormType) => {
    return {
      ...data,
      serviceProvidersLinks: checkboxesGroupMapper.toApiView(data.serviceProvidersLinks),
    };
  };

  return {
    toFormView,
    toApiView
  };
}
